import { z } from 'zod'

const BugListNavigationStateSchema = z.object({
  bugListLocation: z.object({
    pathname: z.string(),
    search: z.string().optional().default(''),
    hash: z.string().optional().default(''),
  }),
})

export function getBugListLocation(state: unknown, projectId: string | undefined) {
  const parsed = BugListNavigationStateSchema.safeParse(state)
  if (!parsed.success || !projectId) return null
  const location = parsed.data.bugListLocation
  const paths = ['projects', 'p'].flatMap(prefix =>
    ['bugs', 'security'].map(section => `/${prefix}/${projectId}/${section}`))
  const reviewerPath = ['projects', 'p'].some(prefix => {
    const base = `/${prefix}/${projectId}/session-reviewers/`
    return location.pathname.startsWith(base) && /^[a-z0-9][a-z0-9-]{0,99}$/.test(location.pathname.slice(base.length))
  })
  return paths.includes(location.pathname) || reviewerPath ? location : null
}
